import { useCallback, useEffect, useState } from "react";
import { Grid, Button, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import BackButton from "components/shared/BackButton";
import { StyledStack, StyledTitle, ButtonContainer } from "./EditProduct.style";
import DrawerCM from "components/shared/Drawer";
import { prodcutColorSchema } from "validations";
import {
  getProductColorInfoRequest,
  deleteProductColorRequest,
  updateProductColorRequest,
} from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import GenarateHeadCell from "helper/generate-head-cell";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteModal from "components/shared/Modal/Delete";

//////////////////////////
const formList = [
  { label: "نام رنگ", type: "text", id: "title", required: true },
  { label: "انتخاب رنگ", type: "color", id: "color_code", required: true },
  { label: "تعداد", type: "text", id: "stock", required: true },
];

export default function EditColor() {
  const params = useParams();
  const navigate = useNavigate();
  const { request, loading } = useHttp(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(prodcutColorSchema),
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  ////////////////// delete color /////////////////
  const onDelete = async () => {
    handelShowModal();
    const res = await request({
      url: deleteProductColorRequest,
      values: params.colorId,
    });
    if (res) {
      navigate(-1);
      Toast({ type: "success", title: "حذف رنگ" });
    }
  };

  ////////////////// submit form /////////////////
  const onSubmit = async (values) => {
    const transformedData = {
      id: params.colorId,
      title: values.title,
      color_code: values.color_code,
      stock: values.stock,
      product_id: values.product_id,
    };
    const res = await request({
      url: updateProductColorRequest,
      values: transformedData,
    });

    if (res) {
      Toast({ type: "success", title: "ویرایش رنگ" });
      reset({
        title: "",
        color_code: "",
        stock: "",
      });
      getProductColorInfo();
    }
  };

  //////////////// intialRequest ////////////////
  const getProductColorInfo = useCallback(async () => {
    let res = await request({
      url: getProductColorInfoRequest,
      values: params.colorId,
    });

    if (res) {
      reset({
        title: res.title,
        color_code: res.color_code,
        stock: res.stock,
        product_id: res.product_id,
      });
    }
  }, [request, params.colorId, reset]);

  useEffect(() => {
    getProductColorInfo();
  }, [getProductColorInfo]);

  return (
    <DrawerCM title="ویرایش رنگ">
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <Grid container my={2}>
            <Grid item mb={-2} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <StyledTitle>ویرایش رنگ</StyledTitle>
              <Grid container>
                {formList.map((items, index) => (
                  <Grid
                    item
                    md={[2].includes(index) ? 12 : 6}
                    xs={12}
                    p={1}
                    key={"add-product" + index}
                  >
                    <TextField
                      id={items.id}
                      label={items.label}
                      type={items.type}
                      variant="outlined"
                      required={items.required}
                      fullWidth
                      multiline={items.id === "description"}
                      rows={items.id === "description" ? 6 : 1}
                      {...register(items.id)}
                      error={Boolean(errors[items.id])}
                      helperText={errors[items.id]?.message}
                    />
                  </Grid>
                ))}

                <ButtonContainer>
                  <Button
                    color="error"
                    startIcon={<DeleteIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handelShowModal}
                  >
                    حذف
                  </Button>
                  <Button
                    color="success"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ثبت
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={onDelete}
          />
        </>
      )}
    </DrawerCM>
  );
}
